import axios from 'axios';
import config from '../config/config';

const ResendOTP = async ( userId ) => {
  try {
    const data ={ 
      userId
    }

    const url = `${config.backendUrl}/v1/main/users/resend-otp`;
    return await axios({
      method: 'POST',
      url,
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.log("error: ",error)
    if(error.code === "ERR_BAD_REQUEST"){
      return error.response
    }
    return {
      status: 404,
    };
  }
};
export default ResendOTP;
